import styled from "styled-components";
import { MARKETPLACE_COLORS, MARKETPLACE_FONTS, gradient, fadeIn } from "./MarketplaceConstants";

export const ProfileCard = styled.div`
  background: white;
  border: 1px solid rgba(23, 23, 23, 0.07);
  border-radius: 14px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 16px rgba(23, 23, 23, 0.04);
  transition: transform 0.2s, box-shadow 0.2s;
  animation: ${fadeIn} 0.4s ease both;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 36px rgba(23, 23, 23, 0.1);
  }
`;

export const ProfileHeader = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 14px;
`;

export const AvatarWrapper = styled.div`
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
`;

export const AvatarPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: ${MARKETPLACE_COLORS.BRAND_GRADIENT};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${MARKETPLACE_FONTS.SANS};
  font-weight: 800;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.2);
`;

export const VerifiedBadge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  background: white;
  border-radius: 50%;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfileMainInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const ProfileName = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 800;
  color: #171717;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProfileTypeBadge = styled.span<{ $type: string }>`
  align-self: flex-start;
  padding: 2px 7px;
  border-radius: 100px;
  font-size: 9px;
  font-weight: 800;
  font-family: ${MARKETPLACE_FONTS.SANS};
  text-transform: uppercase;
  background: ${p => p.$type === "studio" ? "rgba(14, 165, 233, 0.12)" : "rgba(124, 77, 255, 0.12)"};
  color: ${p => p.$type === "studio" ? "#0ea5e9" : "#7c4dff"};
`;

export const ProfileBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
`;

export const ProfileInfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: ${MARKETPLACE_FONTS.SANS};
  font-size: 11px;
  color: rgba(23, 23, 23, 0.6);
  font-weight: 550;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ProfileBio = styled.p`
  margin: 4px 0 0 0;
  font-family: ${MARKETPLACE_FONTS.SANS};
  font-size: 12px;
  color: rgba(23, 23, 23, 0.55);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const SkillTags = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: auto;
  padding-top: 6px;
`;

export const SkillTag = styled.span`
  font-family: ${MARKETPLACE_FONTS.SANS};
  font-size: 9px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.65);
  background: rgba(23, 23, 23, 0.05);
  padding: 2px 6px;
  border-radius: 4px;
`;

export const ProfileFooter = styled.div`
  margin-top: auto;
  display: flex;
`;

export const ConnectBtn = styled.button`
  width: 100%;
  height: 36px;
  border-radius: 9px;
  border: none;
  background: ${MARKETPLACE_COLORS.BRAND_GRADIENT};
  color: white;
  font-family: ${MARKETPLACE_FONTS.SANS};
  font-size: 13px;
  font-weight: 750;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(201, 77, 170, 0.2);
  transition: all 0.2s;

  &:hover {
    opacity: 0.92;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(201, 77, 170, 0.3);
  }
`;

export const MyListingBadge = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 3px 9px;
  border-radius: 100px;
  font-size: 10px;
  font-weight: 700;
  font-family: ${MARKETPLACE_FONTS.SANS};
  background: #171717;
  color: white;
  backdrop-filter: blur(6px);
  z-index: 10;
`;

export const MyReqBadge = styled.span`
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 700;
  font-family: ${MARKETPLACE_FONTS.SANS};
  background: #171717;
  color: white;
  text-transform: capitalize;
`;

export const TrendingSection = styled.section`
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  padding: 80px 40px 100px;
  box-sizing: border-box;
`;

export const TrendingHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 48px;
`;

export const TrendingHeadingCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TrendingSub = styled.div`
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  width: max-content;
  background: var(--mp-heroAccent, linear-gradient(95.57deg, #FFD573 0%, #D863BA 100%)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
`;

export const TrendingTitle = styled.h2`
  margin: 0;
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 400;
  font-size: 40px;
  line-height: 48px;
  color: var(--mp-headingColor, #171717);
`;

export const TrendingNav = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const TrendingArrowBtn = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid var(--mp-border, rgba(23, 23, 23, 0.15));
  background: transparent;
  color: var(--mp-headingColor, #171717);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: var(--mp-headingColor, #171717);
    color: var(--mp-background, #ffffff);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const TrendingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;

  @media (max-width: 991px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const TrendingCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  cursor: pointer;
  
  &:hover img {
    transform: scale(1.04);
  }
`;

export const TrendingCardImageWrap = styled.div`
  width: 100%;
  aspect-ratio: 4 / 3.8;
  border-radius: 24px;
  overflow: hidden;
  position: relative;
`;

export const TrendingCardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
`;

export const TrendingBadge = styled.span<{ $type?: string }>`
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 6px 12px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: ${props => props.$type === 'rent' ? 'rgba(0, 82, 204, 0.9)' : 'rgba(201, 77, 170, 0.9)'};
  color: white;
`;

export const TrendingCardMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TrendingCardCategory = styled.span`
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--mp-heroSubColor, #BEC6E0);
`;

export const TrendingCardTitle = styled.h4`
  margin: 0;
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  color: var(--mp-headingColor, #171717);
`;

export const TrendingCardPrice = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: var(--mp-headingColor, #171717);

  span.amount {
    display: inline-block !important;
    background: var(--mp-heroAccent, linear-gradient(95.57deg, #FFD573 0%, #D863BA 100%)) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    color: transparent !important;
  }

  span.unit {
    font-size: 12px;
    font-weight: 500;
    color: var(--mp-featureDescColor, #434655);
    margin-left: 4px;
  }
`;

export const TalentLinkBtn = styled.span`
  font-size: 14px;
  font-weight: 700;
  position: relative;
  cursor: pointer;
  color: var(--mp-headingColor, #171717);
  transition: opacity 0.2s;
  padding-bottom: 6px;
  display: inline-block;
  
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: var(--mp-heroAccent, var(--mp-heroBtnBg, linear-gradient(95.57deg, #FFD573 0%, #D863BA 100%)));
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const TalentCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  cursor: pointer;

  &:hover img {
    transform: scale(1.04);
  }
`;

export const TalentCardImageWrap = styled.div`
  width: 100%;
  aspect-ratio: 4 / 4.4;
  border-radius: 24px;
  overflow: hidden;
  position: relative;
`;

export const TalentCardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
`;

export const TalentOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 60%, rgba(0, 0, 0, 0) 100%);
  display: flex;
  flex-direction: column;
  gap: 4px;
  pointer-events: none;
`;

export const TalentCardRole = styled.div`
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: max-content;
  background: var(--mp-heroAccent, linear-gradient(95.57deg, #FFD573 0%, #D863BA 100%)) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  color: transparent !important;
`;

export const TalentCardName = styled.h4`
  margin: 0;
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: #ffffff;
`;

export const TalentPillWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TalentPill = styled.span`
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background: var(--mp-cardBackground, #1e2029);
  color: var(--mp-headingColor, #171717);
  opacity: 0.85;
`;

export const TalentQuote = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  font-style: italic;
  color: var(--mp-featureDescColor, #434655);
  opacity: 0.9;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const HowItWorksSection = styled.section`
  width: 100%;
  max-width: 1680px;
  margin: 0 auto;
  padding: 80px 40px 100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const HowItWorksTitle = styled.h2`
  margin: 0 0 12px 0;
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 400;
  font-size: 40px;
  line-height: 48px;
  color: var(--mp-headingColor, #171717);
`;

export const HowItWorksSub = styled.p`
  margin: 0 auto 64px;
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--mp-featureDescColor, #434655);
  max-width: 600px;
  opacity: 0.85;
`;

export const HowItWorksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 64px;
  width: 100%;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: calc(30px + 40px);
    left: calc(100% / 6);
    right: calc(100% / 6);
    height: 2px;
    background: rgba(23, 23, 23, 0.2);
    z-index: 0;
  }

  [data-marketplace-theme="dark"] &::before,
  .dark &::before {
    background: rgba(255, 255, 255, 0.3);
  }

  @media (max-width: 991px) {
    grid-template-columns: 1fr;
    gap: 48px;

    &::before {
      display: none;
    }
  }
`;

export const HowItWorksCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  position: relative;
  z-index: 1;
`;

export const HowItWorksIconBox = styled.div`
  width: 80px;
  height: 80px;
  background: var(--mp-cardBackground, #ffffff);
  border: 1px solid rgba(23, 23, 23, 0.12);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  [data-marketplace-theme="dark"] &,
  .dark & {
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
`;

export const HowItWorksIcon = styled.div<{ $maskUrl: string }>`
  width: 32px;
  height: 32px;
  background: #000000;
  mask-image: url(${props => props.$maskUrl});
  -webkit-mask-image: url(${props => props.$maskUrl});
  mask-size: contain;
  -webkit-mask-size: contain;
  mask-position: center;
  -webkit-mask-position: center;
  mask-repeat: no-repeat;
  -webkit-mask-repeat: no-repeat;

  [data-marketplace-theme="dark"] &,
  .dark & {
    background: #ffffff;
  }
`;

export const HowItWorksNumberBadge = styled.span`
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 700;
  font-size: 18px;
  line-height: 1;
  color: var(--mp-headingColor, #171717);
  opacity: 0.65;
  letter-spacing: 1px;
  margin-bottom: -20px;
  margin-left: 80px;
`;

export const HowItWorksStepTitle = styled.h4`
  margin: 0;
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: var(--mp-headingColor, #171717);
`;

export const HowItWorksStepDesc = styled.p`
  margin: 0;
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: var(--mp-featureDescColor, #434655);
  opacity: 0.85;
`;

export const CtaSection = styled.section`
  width: 100%;
  max-width: 1680px;
  margin: 0 auto 100px;
  padding: 0 40px;
  box-sizing: border-box;
`;

export const CtaCard = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 32px;
  padding: 80px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  background: var(--mp-heroBtnBg, linear-gradient(135deg, #FFD573 0%, #D863BA 100%));

  [data-marketplace-theme="dark"] &,
  .dark & {
    background: ${MARKETPLACE_COLORS.BRAND_GRADIENT};
  }

  @media (max-width: 768px) {
    padding: 48px 24px;
  }
`;

export const CtaTitle = styled.h2`
  margin: 0;
  font-family: ${MARKETPLACE_FONTS.SERIF};
  font-weight: 700;
  font-size: 48px;
  line-height: 56px;
  max-width: 800px;
  color: #ffffff;

  [data-marketplace-theme="dark"] &,
  .dark & {
    color: #402D00;
  }

  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 40px;
  }
`;

export const CtaDesc = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  max-width: 600px;
  color: #ffffff;
  opacity: 0.9;

  [data-marketplace-theme="dark"] &,
  .dark & {
    color: #402D00;
    opacity: 0.85;
  }
`;

export const CtaButtons = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`;

export const CtaPrimaryBtn = styled.button`
  border: none;
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s;
  background: #ffffff;
  color: var(--mp-featureIconColor, #D863BA);
  font-family: ${MARKETPLACE_FONTS.SANS};

  [data-marketplace-theme="dark"] &,
  .dark & {
    background: #402D00;
    color: #ffffff;
  }

  &:hover {
    opacity: 0.9;
  }
`;

export const CtaSecondaryBtn = styled.button`
  padding: 16px 32px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #ffffff;
  font-family: ${MARKETPLACE_FONTS.SANS};

  [data-marketplace-theme="dark"] &,
  .dark & {
    border: 1px solid rgba(64, 45, 0, 0.4);
    color: #402D00;
  }

  &:hover {
    opacity: 0.8;
  }
`;
